import { useQuery } from "@tanstack/react-query";
import newApi, { defaultAppConfig } from "src/newApi";

import { queryClient } from "src/queryClient";
import options from "./defaultOptions";

export function useGetAppConfig(enabled) {
	return useQuery({
		queryKey: ["app-config"],
		queryFn: () => newApi.getAppConfig(),
		...options,
		staleTime: 5 * 60 * 1000,
		refetchInterval: 5 * 60 * 1000,
		enabled,
	});
}

export function getAppConfig() {
	return queryClient.getQueryData(["app-config"]);
}

export function getMaxQuestions() {
	const config = getAppConfig();

	return config.maxQuestions;
}

// guide (faq) is hidden everywhere unless the backend turns it on
export function isFaqEnabled() {
	return getAppConfig()?.faq ?? defaultAppConfig.faq;
}

// chatbot AI jest ukryty, dopóki backend go nie włączy
export function isAiChatbotEnabled() {
	return getAppConfig()?.aiChatbotEnabled ?? defaultAppConfig.aiChatbotEnabled;
}

export function getMaxDecksInBatch() {
	const config = getAppConfig();

	return (
		config?.decks?.maxDecksInBatch ?? defaultAppConfig.decks.maxDecksInBatch
	);
}

export function getMaxImageSizeMb() {
	return getAppConfig()?.maxImageSizeMb ?? defaultAppConfig.maxImageSizeMb;
}
